/*###########################################################################
// Components
//#########################################################################*/

/* Dynamic Components
//------------------*/

if (document.querySelector('.accordion')) {
  import('./_accordions')
}

if (document.querySelector('.copy-clipboard')) {
	import('./_copyClipboard')
}

if (document.querySelector('.heroHome')) {
	import('./_heroHome')
}

if (document.querySelector('.hubspotGated')) {
	import('./_hubspotGated')
}

if (document.querySelector('.modal')) {
	import('./_modals')
}

if (document.querySelector('.rental-dates')) {
	import('./_rentalDates')
}

if (document.querySelector('.responsive-video')) {
	import('./_responsiveVideo')
}

if (document.querySelector('.sprigFilter')) {
	import('./_sprigFilter')
}

if (document.querySelector('.sliderCardProductPackages')) {
	import('./_sliderCardProductPackages')
}

if (document.querySelector('.sliderContent')) {
	import('./_sliderContent')
}

if (document.querySelector('.sliderGeneric')) {
	import('./_sliderGeneric')
}

if (document.querySelector('.sliderMultiImage')) {
	import('./_sliderMultiImage')
}

if (document.querySelector('.sliderProduct')) {
	import('./_sliderProduct')
}

if (document.querySelector('.sliderTestimonials')) {
	import('./_sliderTestimonials')
}

if (document.querySelector('.stickyComponent')) {
	import('./_stickyComponent')
}

/* Standard Components
//------------------*/

import './_browserDetect'
import './_footer'
import './_forms'
import './_lazyImagesScrollTrigger'
import './_reveal'
import './_signUpForm'
import './_tooltips'
